module.exports = __webpack_public_path__ + "static/media/bg-tomatoes.699044b3.jpg";